import styled from "styled-components";

export const AnnualIncomeContainer = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
`;

export const AnnualIncomeLabel = styled.label`
  display: block;
  margin-bottom: 1.5rem;
  font-family: "Geist", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #181d27;
  line-height: 1.5;
`;

export const SliderContainer = styled.div`
  margin-bottom: 1.5rem;
`;

export const SliderTrack = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 0.75rem;
`;

export const SliderRange = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 8px;
  width: ${({ $percentage }) => $percentage}%;
  background: #181d27;
  border-radius: 4px;
  transition: width 0.2s ease-in-out;
  pointer-events: none;
  z-index: 0;
`;

export const SliderThumb = styled.input`
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  outline: none;
  cursor: pointer;

  /* Hide default slider styling */
  -webkit-appearance: none;
  appearance: none;

  &::-webkit-slider-track {
    width: 100%;
    height: 8px;
    background: #e5e7eb;
    border-radius: 4px;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background-color: #fff;
    border: 2px solid #d5d7da;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    position: relative;
    z-index: 1;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
  }

  /* Hide slider thumb when dropdown is open */
  body.dropdown-open &::-webkit-slider-thumb {
    opacity: 0;
    visibility: hidden;
  }

  &::-moz-range-track {
    width: 100%;
    height: 8px;
    background: #e5e7eb;
    border-radius: 4px;
    border: none;
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background-color: #2563eb;
    border: 3px solid #ffffff;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    z-index: 1;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
  }

  /* Hide slider thumb when dropdown is open */
  body.dropdown-open &::-moz-range-thumb {
    opacity: 0;
    visibility: hidden;
  }

  &:focus {
    outline: none;

    &::-webkit-slider-thumb {
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    &::-moz-range-thumb {
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;

    &::-webkit-slider-thumb {
      cursor: not-allowed;

      &:hover {
        transform: none;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
    }

    &::-moz-range-thumb {
      cursor: not-allowed;

      &:hover {
        transform: none;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
    }
  }
`;

export const RangeLabels = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RangeLabel = styled.span`
  font-family: "Geist", sans-serif;
  font-size: 14px;
  color: #717184;
  font-weight: 400;
`;

export const IncomeInput = styled.input`
  width: 100%;
  padding: 16px 20px;
  border-radius: 8px;
  background-color: #ffffff;
  color: #6b7280; /* Light tone color for the text */
  font-family: "Geist", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  transition: all 0.2s ease-in-out;
  border: 1px solid var(--Colors-Border-border-primary, #d5d7da);
  box-shadow: 0 1px 2px 0
    var(--Colors-Effects-Shadows-shadow-xs, rgba(10, 13, 18, 0.05));
  pointer-events: none; /* Disable all mouse interactions */
  user-select: none; /* Prevent text selection */
  cursor: default; /* Show default cursor instead of text cursor */

  &::placeholder {
    color: #9ca3af;
  }

  /* Removed hover and focus styles since input is readonly */

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: #f9fafb;
    border-color: #e5e7eb;
  }
`;
